import StyledLocalLink from "features/shared/components/link/styles/StyledLocalLink.styled";
import styled from "styled-components";

import ConsentCard from "./ConsentCard.styled";

const StyledConsentPage = styled.div`
  padding: 24px 0;
  ${ConsentCard} {
    margin-top: 24px;
  }

  ${StyledLocalLink} {
    margin-bottom: 24px;
  }
`;

export default StyledConsentPage;
